const initialSendData = {
  tableData:[],
  // tableData: [
  //   {
  //     productCode: "1254",
  //     nameMaterial: "لباس",
  //     number: 5,
  //     price: "1230000",
  //     returnStatus: "بله",
  //     totalSum: "32654",
  //   },
  //   {
  //     productCode: "1254",
  //     nameMaterial: "لباس",
  //     number: 5,
  //     price: "1230000",
  //     returnStatus: "بله",
  //     totalSum: "32654",
  //   },
  //   {
  //     productCode: "1254",
  //     nameMaterial: "لباس",
  //     number: 5,
  //     price: "1230000",
  //     returnStatus: "بله",
  //     totalSum: "32654",
  //   },
  //   {
  //     productCode: "1254",
  //     nameMaterial: "لباس",
  //     number: 5,
  //     price: "1230000",
  //     returnStatus: "بله",
  //     totalSum: "32654",
  //   },
  //   {
  //     productCode: "1254",
  //     nameMaterial: "لباس",
  //     number: 5,
  //     price: "1230000",
  //     returnStatus: "بله",
  //     totalSum: "32654",
  //   },
  //   {
  //     productCode: "1254",
  //     nameMaterial: "لباس",
  //     number: 5,
  //     price: "1230000",
  //     returnStatus: "بله",
  //     totalSum: "32654",
  //   },
  // ],
  date:'',
  clientCode:'',
  salaryTitle:'',
  amount:'',
  returnStatus:'',
  exitStatus:'',
  description:'',
  
};

const initialData = {
  clientCode: [
    { label: "545", value: "245" },
    { label: "545", value: "245" },
    { label: "545", value: "245" },
    { label: "545", value: "245" },
    { label: "545", value: "245" },
  ],
  returnStatus: [
    { label: "کل فاکتور", value: "1" },
    { label: "داده نشد", value: "2" },
  ],
  exitStatus: [
    { label: "ورود به بخش تولید", value: "1" },
    { label: "فروش مواد اولیه", value: "2" },
  ],
  options: [
    { label: "سبد", value: "3256" },
    { label: "لباس", value: "1958" },
    { label: "کیف", value: "3265" },
    { label: "کفش", value: "9547" },
  ],
};

const componentData = {
  sumTotalInvoice:0,
};

const ReturnedGoodsFactorData = {
  initialSendData,
  initialData,
  componentData,
};

export default ReturnedGoodsFactorData;
